export default __webpack_public_path__ + "static/media/orienta_negative.4966b1e7.png";